var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dayjs from "dayjs";
var getFareFamilyParams = function (amadeusFareFamilies) {
    var params = {};
    if (amadeusFareFamilies) {
        for (var i = 0; i < amadeusFareFamilies.length; i++) {
            var family = amadeusFareFamilies[i];
            params["COMMERCIAL_FARE_FAMILY_".concat(i + 1)] = family;
        }
    }
    return params;
};
var isCompanionPricing = function (_a) {
    var _b, _c;
    var tripType = _a.tripType, passengerAndCabinClass = _a.passengerAndCabinClass, itineraries = _a.itineraries, companionPricing = _a.companionPricing;
    if (tripType === 'M' || !passengerAndCabinClass || !itineraries || !companionPricing) {
        return false;
    }
    // Loop over companion pricing
    for (var i = 0; i < companionPricing.length; i++) {
        var companionPrice = companionPricing[i];
        var currentDate = dayjs();
        var saleStartDate = dayjs(companionPrice.saleStartDate);
        var saleEndDate = dayjs(companionPrice.saleEndDate);
        if ((!currentDate.isAfter(saleStartDate) && !currentDate.isSame(saleStartDate)) || !currentDate.isBefore(saleEndDate) && !currentDate.isSame(saleEndDate)) {
            continue;
        }
        // Check if the trip type matches
        if (companionPrice.tripType === 'both' || companionPrice.tripType.toUpperCase().charAt(0) === tripType) {
            // Check if the passenger counts match
            if (companionPrice.adults === passengerAndCabinClass.adults && companionPrice.youth === passengerAndCabinClass.youth && companionPrice.child === passengerAndCabinClass.child && companionPrice.infant === passengerAndCabinClass.infant) {
                if (companionPrice.from === ((_b = itineraries[0].fromAirport) === null || _b === void 0 ? void 0 : _b.locIATA) && companionPrice.to === ((_c = itineraries[0].toAirport) === null || _c === void 0 ? void 0 : _c.locIATA)) {
                    // Check if the departure date is within the range
                    var travelStartDate = dayjs(companionPrice.travelStartDate);
                    var travelEndDate = dayjs(companionPrice.travelEndDate);
                    var departureDate = dayjs(itineraries[0].departureDate);
                    if (departureDate.isAfter(travelStartDate) && departureDate.isBefore(travelEndDate)) {
                        return true;
                    }
                }
            }
        }
    }
    return false;
};
var getPassengerParams = function (passengerAndCabinClass, isMulti) {
    var params = {};
    if (passengerAndCabinClass) {
        var cabinMapping = {
            economy: isMulti ? 'R' : 'E',
            business: 'B',
        };
        var cabinParamName = isMulti ? 'CABIN' : 'Cabin';
        params[cabinParamName] = cabinMapping[passengerAndCabinClass.cabin];
        var adults = 0;
        var child = 0;
        var youth = 0;
        var infant = 0;
        for (var i = 1; i < 10; i++) {
            if (adults < passengerAndCabinClass.adults) {
                params["TRAVELLER_TYPE_".concat(i)] = 'ADT';
                adults++;
                if (infant < passengerAndCabinClass.infant) {
                    params["HAS_INFANT_".concat(i)] = 'TRUE';
                    infant++;
                }
            }
            else if (child < passengerAndCabinClass.child) {
                params["TRAVELLER_TYPE_".concat(i)] = 'CHD';
                child++;
            }
            else if (youth < passengerAndCabinClass.youth) {
                params["TRAVELLER_TYPE_".concat(i)] = 'B15';
                youth++;
            }
        }
    }
    return params;
};
var getItineraryAirportCode = function (itinerary, fromOrTo) {
    var _a, _b, _c, _d;
    if (fromOrTo === void 0) { fromOrTo = 'from'; }
    switch (fromOrTo) {
        case 'to':
            return (_a = itinerary.toAirportCode) !== null && _a !== void 0 ? _a : (_b = itinerary.toAirport) === null || _b === void 0 ? void 0 : _b.locIATA;
        case 'from':
        default:
            return (_c = itinerary.fromAirportCode) !== null && _c !== void 0 ? _c : (_d = itinerary.fromAirport) === null || _d === void 0 ? void 0 : _d.locIATA;
    }
};
var getItineraryParams = function (itineraries) {
    var params = {};
    if (itineraries) {
        var filteredItineraries = itineraries.filter(function (itinerary) { return !itinerary.ignore; });
        var isMultiCity = false;
        if (filteredItineraries.length === 1) {
            // If there is only one itinerary this trip is one way
            params.TRIP_TYPE = 'O';
        }
        else if (filteredItineraries.length === 2 && getItineraryAirportCode(filteredItineraries[0], 'from') === getItineraryAirportCode(filteredItineraries[1], 'to') && getItineraryAirportCode(filteredItineraries[0], 'to') === getItineraryAirportCode(filteredItineraries[1], 'from')) { // If there are two it could be multi-city or return, need to check airport codes
            params.TRIP_TYPE = 'R';
        }
        else {
            isMultiCity = true;
            params.TRIP_TYPE = 'M';
            params.EXTERNAL_ID = 'MULTI';
            params.EMBEDDED_TRANSACTION = 'AirComplexAvailability';
            params.SEVEN_DAY_SEARCH = 'TRUE';
            params.SO_SITE_MIN_AVAIL_DATE_SPAN = 'H0';
            params.SO_SITE_MAX_NUM_DIFF_CITY = '6';
        }
        for (var i = 0; i < filteredItineraries.length; i++) {
            var itinerary = filteredItineraries[i];
            var fromAirportCode = getItineraryAirportCode(itinerary, 'from');
            var toAirportCode = getItineraryAirportCode(itinerary, 'to');
            if (fromAirportCode) {
                params["B_LOCATION_".concat(i + 1)] = fromAirportCode;
            }
            if (toAirportCode) {
                params["E_LOCATION_".concat(i + 1)] = toAirportCode;
            }
            if (itinerary.departureDate) {
                params["B_DATE_".concat(i + 1)] = dayjs(itinerary.departureDate).format('YYYYMMDDHHmm');
            }
            if (isMultiCity) {
                params["B_ANY_TIME_".concat(i + 1)] = 'TRUE';
            }
        }
    }
    return params;
};
export var getItineraryScheduleParams = function (itineraries) {
    var params = {};
    if (itineraries) {
        var filteredItineraries = itineraries.filter(function (itinerary) { return !itinerary.ignore; });
        if (filteredItineraries.length === 1) {
            // If there is only one itinerary this trip is one way
            params.TRIP_TYPE = 'O';
        }
        else if (filteredItineraries.length === 2 && getItineraryAirportCode(filteredItineraries[0], 'from') === getItineraryAirportCode(filteredItineraries[1], 'to') && getItineraryAirportCode(filteredItineraries[0], 'to') === getItineraryAirportCode(filteredItineraries[1], 'from')) { // If there are two it could be multi-city or return, need to check airport codes
            params.TRIP_TYPE = 'R';
        }
        else {
            params.TRIP_TYPE = 'M';
        }
        var itinerary = filteredItineraries[0];
        var endItinerary = filteredItineraries[1];
        var fromAirportCode = getItineraryAirportCode(itinerary, 'from');
        var toAirportCode = getItineraryAirportCode(itinerary, 'to');
        if (fromAirportCode) {
            params["B_LOCATION"] = fromAirportCode;
        }
        if (toAirportCode) {
            params["E_LOCATION"] = toAirportCode;
        }
        if (itinerary.departureDate) {
            params["B_DATE"] = dayjs(itinerary.departureDate).format('YYYYMMDDHHmm');
        }
        if (endItinerary === null || endItinerary === void 0 ? void 0 : endItinerary.departureDate) {
            params["E_DATE"] = dayjs(endItinerary.departureDate).format('YYYYMMDDHHmm');
        }
    }
    return params;
};
export default function createAmadeusActionQueryParams(_a) {
    var amadeusParams = _a.amadeusParams, 
    // amadeusFareFamilies,
    itineraries = _a.itineraries, promoCode = _a.promoCode, passengerAndCabinClass = _a.passengerAndCabinClass, companionPricing = _a.companionPricing;
    var params = __assign(__assign({}, (amadeusParams !== null && amadeusParams !== void 0 ? amadeusParams : {})), { TRAVELLER_TYPE_1: 'ADT', TRAVELLER_TYPE_2: '', TRAVELLER_TYPE_3: '', TRAVELLER_TYPE_4: '', TRAVELLER_TYPE_5: '', TRAVELLER_TYPE_6: '', TRAVELLER_TYPE_7: '', TRAVELLER_TYPE_8: '', TRAVELLER_TYPE_9: '', HAS_INFANT_1: 'FALSE', HAS_INFANT_2: 'FALSE', HAS_INFANT_3: 'FALSE', HAS_INFANT_4: 'FALSE', HAS_INFANT_5: 'FALSE', HAS_INFANT_6: 'FALSE', HAS_INFANT_7: 'FALSE', HAS_INFANT_8: 'FALSE', HAS_INFANT_9: 'FALSE', PROMOCODE: promoCode !== null && promoCode !== void 0 ? promoCode : '' });
    var itineraryParams = getItineraryParams(itineraries);
    // const fareFamilyParams = getFareFamilyParams(amadeusFareFamilies);
    var passengerParams = getPassengerParams(passengerAndCabinClass, itineraryParams.TRIP_TYPE === 'M');
    params = __assign(__assign(__assign({}, params), passengerParams), itineraryParams);
    // If combined adults count = 2 and all other passengers are 0 and companionPricing is true, then set TRAVELLER_TYPE_1 to CMA and TRAVELLER_TYPE_2 to CMP
    if (isCompanionPricing({
        tripType: itineraryParams.TRIP_TYPE,
        passengerAndCabinClass: passengerAndCabinClass,
        itineraries: itineraries !== null && itineraries !== void 0 ? itineraries : [],
        companionPricing: companionPricing !== null && companionPricing !== void 0 ? companionPricing : [],
    })) {
        params["TRAVELLER_TYPE_1"] = 'CMA';
        params["TRAVELLER_TYPE_2"] = 'CMP';
    }
    return params;
}
